import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Button } from "react-bootstrap";
import DeleteIcon from 'mdi-react/DeleteIcon';
import { destroy } from "../../../utils/DeApi";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";

class CatalogueRemove extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {};
  }

  removeFromCatalogue() {
    const { catalogued, onFilingRemoved } = this.props;
    this.setState({ error: null, isLoading: true });
    const removePromise = destroy(
      `/catalogues/${moment.utc(catalogued.filedAt).format("YYYY-MM-DD")}`,
      {
        params: {
          formType: catalogued.formType,
          filingId: catalogued.filingId,
          ...( catalogued?.documentId && {documentId: catalogued?.documentId}),
        },
      }
    );
    removePromise.promise
      .then((response) => {
        this.setState({ error: null, isLoading: false }, () =>
          onFilingRemoved(catalogued)
        );
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
    this.subscribedPromises.push(removePromise);
  }

  render() {
    const { isLoading, error } = this.state;
    const { screen, show } = this.props;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    if(screen === 'selection'){
      // return (<Button
      //   variant="default"
      //   size="sm"
      //   onClick={() => this.removeFromCatalogue()}
      //   className="btn-success-deal-style roundedEdges"
      // >
      //   <span className="material-icons md-18">delete_outline</span>{" "}
      // </Button>);
      return ( <Button
          variant='null'
          size='sm' 
          className='p-1 color-deal-style'
          title="Remove this Selection"
          onClick={() => this.removeFromCatalogue()} >
            <DeleteIcon size={20} />
        </Button>
      );
    }
    return (
      show ? (<Button
        variant="warning"
        size="sm"
        onClick={() => this.removeFromCatalogue()}
        className="roundedEdges"
      >
        {/* <span className="material-icons md-18">delete_outline</span>{" "} */}
        Add Document
      </Button>) : (<></>)
    );
  }
}

CatalogueRemove.propTypes = {
  catalogued: PropTypes.object.isRequired,
  onFilingRemoved: PropTypes.func.isRequired,
};

export default CatalogueRemove;
